import { useState } from 'react';
import { Button } from '../../components/ui/Button';
import { TextField } from '../../components/ui/TextField';

export function SearchAskPage() {
  const [q, setQ] = useState('');

  return (
    <div className="flex flex-col gap-6">
      <section className="rounded-md border border-umb-neutral-mid bg-white p-6">
        <h2 className="text-base font-semibold text-umb-neutral-dark">
          Grounded search
        </h2>
        <p className="mt-1 text-sm text-umb-neutral-dark/70">
          Packages, admitted assets, evidence references, and servicing-visible
          documents.
        </p>
        <form
          className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-end"
          onSubmit={(e) => e.preventDefault()}
        >
          <TextField
            id="search-q"
            label="Query"
            placeholder="Search by package, loan, ISIN, or document hash"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="min-w-0 flex-1"
          />
          <Button type="submit" variant="primary" className="sm:mb-0">
            Search
          </Button>
        </form>
      </section>

      <section className="rounded-md border border-umb-neutral-mid bg-white p-6">
        <h2 className="text-base font-semibold text-umb-neutral-dark">
          IDA ask
        </h2>
        <p className="mt-1 text-sm text-umb-neutral-dark/70">
          Conversational access with citations to evidence and metadata
          (wireframe pattern).
        </p>
        <div className="mt-4 min-h-[200px] rounded-md border border-dashed border-umb-neutral-mid bg-umb-neutral-light/30 p-4 text-sm text-umb-neutral-dark/50">
          Ask a question about custody state, document gaps, or program rules.
          Responses appear here with grounded references.
        </div>
        <div className="mt-4 flex gap-2">
          <input
            type="text"
            className="min-w-0 flex-1 rounded-md border border-umb-neutral-mid px-3 py-2 text-sm focus:border-umb-primary focus:outline-none focus:ring-2 focus:ring-umb-primary/25"
            placeholder="Type your question…"
            aria-label="IDA question"
          />
          <Button type="button" variant="primary">
            Send
          </Button>
        </div>
      </section>
    </div>
  );
}
